module.exports = "../../../../platform/assets/pageMainIcon/industry_jichudanganlei5.svg";